import SocialMediaIconFB from "../../assets/photobooth/Social-Media-icon-fb.png";
import SocialMediaIconInsta from "../../assets/photobooth/Social-Media-icon-insta.png";
import SocialMediaIconTwitter from "../../assets/photobooth/Social-Media-icon-twitter.png";
import SocialMediaIconLinkedin from "../../assets/photobooth/Social-Media-icon-linkedin.png";
import React, {memo} from "react";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";

const styles = {
    shareSocial: {
        margin: '3.5vw auto 2.2vw',
        fontSize: '1.1vw',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'space-evenly'
    }
}

const Links = {
    FACEBOOK: '//www.facebook.com',
    INSTAGRAM: '//www.instagram.com',
    TWITTER: '//www.twitter.com',
    LINKEDIN: '//www.linkedin.com',
}

const useStyles = makeStyles({
    shareIcon: {
        cursor: 'pointer',
        margin: '0.5vw 0.1vw',
        width: '4vw'
    }
});

const ShareSocialIcons = ({}) => {

    const classes = useStyles()

    return (<div style={styles.shareSocial}>
        <Link to={Links.FACEBOOK} target='_blank'>
            <img className={classes.shareIcon} src={SocialMediaIconFB} alt={'FB'}/>
        </Link>
        <Link to={Links.INSTAGRAM} target='_blank'>
            <img className={classes.shareIcon} src={SocialMediaIconInsta} alt={'Inst'}/>
        </Link>
        <Link to={Links.TWITTER} target='_blank'>
            <img className={classes.shareIcon} src={SocialMediaIconTwitter} alt={'Twitter'}/>
        </Link>
        <Link to={Links.LINKEDIN} target='_blank'>
            <img className={classes.shareIcon} src={SocialMediaIconLinkedin} alt={'In'}/>
        </Link>
    </div>);
}

export default memo(ShareSocialIcons);